export enum HoverImageAction {
  Image = 'image',
  Scale = 'scale',
  None = 'none',
  Video = 'video',
}

export const DEFAULT_SCALE_FOR_PRESET = 1.05;
export const DESIGN_PANEL_SCALE = 0.78;
export const LABEL_FONT_SIZE = 12;
